module.exports = __webpack_public_path__ + "static/media/BUENFIN.d3340143.jpg";